module.exports = __webpack_public_path__ + "img/39_32.41122268.png";